import React from 'react';

import styles from './InternalCamBadge.module.scss';

const InternalCamBadge = () => (
  <div className={styles.badge} data-testid="internal-cam-badge">
    Internal
  </div>
);

InternalCamBadge.displayName = 'InternalCamBadge';

export default React.memo(InternalCamBadge);
